import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/root';
import { ROUTES } from '../components/Routes/ClientRoutes';
import { setSelectedPermit } from '../../../redux/slices/inspectionsSlice';
import { setSelectedPermitTicket } from '../../../redux/slices/ticketsSlice';
import { setSelectedDocumentPermit } from '../../../redux/slices/documentsSlice';
import { setSelectedFee } from '../../../redux/slices/feesSlice';
import { setSelectedActivityPermit } from '../../../redux/slices/clientActivitiesSlice';

export type ProjectViewItem = {
  label: string;
  qty: number;
  route: string;
};

const useProjectsViewItems = () => {
  const initialData: ProjectViewItem[] = [
    { label: 'Activities', qty: 0, route: `${ROUTES.ACTIVITIES}?openDrawer=true` },
    { label: 'Documents', qty: 0, route: `${ROUTES.DOCUMENTS}?openDrawer=true` },
    { label: 'Inspections', qty: 0, route: `${ROUTES.INSPECTIONS}?openDrawer=true` },
    { label: 'Conditions', qty: 0, route: `${ROUTES.CONDITIONS}?openDrawer=true` },
    { label: 'Fees', qty: 0, route: `${ROUTES.INVOICES}?openDrawer=true` },
    { label: 'Tickets', qty: 0, route: `${ROUTES.TICKETS}?openDrawer=true` },
  ];
  const [linkedItems, setLinkedItems] = useState(initialData);
  const dispatch = useDispatch();
  const selectedPermit = useSelector((state: RootState) => state.projectsSlice.selectedPermit);
  const permitInspectionsList = useSelector((state: RootState) => state.inspections.permitInspectionsList);
  const AllPermitsWithConditions = useSelector((state: RootState) => state.conditions.AllPermitsWithConditions);
  const AllPermitsWithDocs = useSelector((state: RootState) => state.documents.AllPermitsWithDocs);
  const permitTicketsList = useSelector((state: RootState) => state.tickets.permitTicketsList);
  const showDrawerContent = useSelector((s: RootState) => s.general.showDrawerContent);
  const clientProjecPermitList = useSelector((s: RootState) => s.fees.clientProjecPermitList);
  const AllPermitsWithActivities = useSelector(
    (s: RootState) => s.clientActivities.AllPermitsWithActivities,
  );

  useEffect(() => {
    if (!showDrawerContent) {
      setLinkedItems(initialData);
      return;
    }
    const condition = AllPermitsWithConditions.find(pi => pi.permitId == selectedPermit.permitId);
    const inspection = permitInspectionsList.find(pi => pi.permitId == selectedPermit.permitId);
    const document = getDocQty();
    const fee = getFeeQty();
    const ticket = permitTicketsList.find(pi => pi.permitId == selectedPermit.permitId);
    // eslint-disable-next-line eqeqeq
    const activity = AllPermitsWithActivities.find(pi => pi.permitId == selectedPermit.permitId);

    const _items = initialData.map(item => {
      if (item.label === 'Conditions' && condition) {
        return {
          ...item,
          qty: condition.quantity || condition.tableQty,
        };
      }
      if (item.label === 'Inspections' && inspection) {
        // @ts-ignore
        dispatch(setSelectedPermit(inspection));
        return {
          ...item,
          qty: inspection.quantity,
        };
      }

      if (item.label === 'Documents' && document) {
        // @ts-ignore
        dispatch(setSelectedDocumentPermit(document));
        return {
          ...item,
          qty: document.quantity,
        };
      }

      if (item.label === 'Fees' && fee) {
        dispatch(setSelectedFee(fee));
        return {
          ...item,
          qty: fee.quantity,
        };
      }

      if (item.label === 'Activities' && activity) {
        // @ts-ignore
        dispatch(setSelectedActivityPermit(activity));
        return {
          ...item,
          qty: activity.quantity,
        };
      }

      if (item.label === 'Tickets' && ticket) {
        dispatch(setSelectedPermitTicket(ticket));
        return {
          ...item,
          qty: ticket.quantity,
        };
      }
      return item;
    });

    setLinkedItems(_items);
  }, [showDrawerContent, AllPermitsWithActivities]);

  const getDocQty = () => {
    const permitIds = (selectedPermit?.permits || []).map(p => Number(p.id));
    const doc = AllPermitsWithDocs.find(pi => permitIds.indexOf(Number(pi.permitId)) > -1);
    let qty = 0;
    if (doc) {
      qty = doc.quantity;
    }
    return {
      quantity: qty,
    };
  };

  const getFeeQty = () => {
    const prj = clientProjecPermitList.find(cp => cp.id === selectedPermit.id);
    const count = prj ? prj.permit.invoices.length : 0;
    return {
      quantity: count,
    };
  };
  return { selectedPermit, linkedItems };
};

export default useProjectsViewItems;
